export enum AttachmentType {
  ATTACHMENT = 'attachment',
  APPROVAL = 'approval',
  DECLINATION = 'declination',
}
